import React, { memo, ReactElement, useEffect, useRef, useState } from 'react';
import { Group } from 'three';
import { useDataStore } from '../../zustand';
import { IRoot, ISceneComp, ITrackingTypes } from '@r3f-component-data-structure';
import { useThree } from '@react-three/fiber';
import PlacementScene from './PlacementScene';
import { useGetCurrentSceneId } from '@/hooks/general';



const getPlacementSceneName = (sceneId: string) => `pacement_scene_${sceneId}`;

const PlacementScenes: React.FunctionComponent = () => {
	const componentsById = useDataStore((state) => state.componentsById);
	const rootId = useDataStore((state) => state.rootId);

	const worldTrackedScenesIds = (componentsById?.[rootId ?? ''] as IRoot).children.filter(sceneId => (componentsById?.[sceneId] as ISceneComp).trackingType === ITrackingTypes.world) ?? []; 
	const placementScenes = worldTrackedScenesIds.map(worldTrackedSceneId => <group name={getPlacementSceneName(worldTrackedSceneId)}><PlacementScene sceneId={worldTrackedSceneId} /></group>)

	return <>{placementScenes}</>;
};

PlacementScenes.displayName = 'PlacementScenes';
export default memo(PlacementScenes);
